<template>
  <div>
    <v-container>
      <v-row>
        <v-col>
          <wc-data-box
            title='All Projects'
            :titleIcon='$store.state.icons.modules.projects.icon'
            titleIconColor='grey'
          >
            <template v-slot:toolbarButtons>
              <wc-show-archived-button
                v-model='showArchived'
                @toggleShowArchived='showArchived = !showArchived'
              ></wc-show-archived-button>
              <wc-toolbar-search v-model='search'></wc-toolbar-search>
            </template>
            <v-data-table
              :loading='isLoading'
              dense
              sort-by='date_due'
              :search='search'
              :items='filteredProjects'
              :headers='headers'
              @click:row='openProject'
              :items-per-page='20'
            >
              <template v-slot:item.project_name='{ item }'>
                {{ item.project_name }}
                <wc-archived v-if='item.project_archived'></wc-archived>
              </template>
              <template v-slot:item.project_division_obj.division='{ item }'>
                <span v-if='item.project_division_obj.division'>
                  <wc-division-nai :division_obj='item.project_division_obj'></wc-division-nai>
                </span>
              </template>
              <template v-slot:item.project_site_address='{ item }'>
               {{ item.project_site_address + ', ' + item.project_site_city}}
              </template>
              <template v-slot:item.relationship='{ item }'>
                <!-- {{ item.relationship }} -->
                <wc-contact-role-chips :relationship='item.relationship'></wc-contact-role-chips>
              </template>
            </v-data-table>
          </wc-data-box>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import clientsAPI from '@/modules/clients/api/clients'
import _ from 'lodash'

export default {
  name: 'client-projects',
  props: {
    client: {
      required: true
    }
  },
  data: () => ({
    search: "",
    projects: [],
    temp: [],
    isLoading: true,
    showArchived: false,
    headers: [
      { text: 'Project Name', value: 'project_name' },
      { text: 'Division', value: 'project_division_obj.division', align: 'start' },
      { text: 'Site Address', value: 'project_site_address' },
      { text: 'Role', value: 'relationship', align: 'start' }
    ],
  }),
  created () {
    this.getProjects ()
  },
  computed: {
    filteredProjects () {
      let tmp = _.uniqBy(this.projects, 'project_id')
      return this.showArchived ? tmp : _.filter(tmp, p => !p.project_archived)
    }
  },
  methods: {
    openProject (item) {
      this.$router.push({ name: item.project_division_obj.division + 'Overview', params: { id: item.project_id } })
    },
    async getProjects () {
      this.isLoading = true
      let projects = await clientsAPI.getConnectedProjects(this.client.id)
      this.projects = _.uniqBy(projects, 'project_id')
      let duplicates = _.difference(projects, this.projects)
      duplicates.forEach( d => {
        let index = _.findIndex(this.projects, p => p.project_id === d.project_id)
        this.projects[index].relationship += ','
        this.projects[index].relationship += d.relationship
      })
      this.isLoading = false
    }
  }
}
</script>
